export default __webpack_public_path__ + "static/media/customer-3.6d81e7ff.png";